import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalRecommendationComponent } from './modal-recommendation.component'
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { BlockUIModule } from '../../block-ui';


@NgModule({
  declarations: [
    ModalRecommendationComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    BlockUIModule
  ]
})
export class ModalRecommendationModule { }
